import { render, staticRenderFns } from "./placeOrder.vue?vue&type=template&id=0e0d3238&scoped=true&"
import script from "./placeOrder.vue?vue&type=script&lang=js&"
export * from "./placeOrder.vue?vue&type=script&lang=js&"
import style0 from "./placeOrder.vue?vue&type=style&index=0&lang=css&"
import style1 from "./placeOrder.vue?vue&type=style&index=1&id=0e0d3238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0d3238",
  null
  
)

export default component.exports